module.exports = __webpack_public_path__ + "img/PLoader.2963321e.png";